import styled from "styled-components";

export const Main = styled.div`
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media only screen and (max-device-width: 900px) {
		flex-direction: column;
	}
`;

export const Container = styled.div`
	width: 50%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	background: #23242f;

	@media only screen and (max-device-width: 900px) {
		width: 100%;
		background: #13141b;
	}

	@media only screen and (max-device-width: 380px) {
		height: 40rem;
	}
`;

export const Content = styled.section`
	width: 27rem;
	height: 100%;
	background: #23242f;
	z-index: 1000;

	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	font-family: "MetropolisRegular";

	@media only screen and (max-device-width: 900px) {
		width: 100%;
		background: #13141b;
		position: relative;
		max-width: 23rem;
		height: 90%;
		justify-content: flex-start;
	}

	@media only screen and (max-device-width: 380px) {
		width: 85%;
	}
`;

export const Title = styled.div`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
`;

export const Subtitle = styled.span`
	font-size: 16px;
	color: #ffffff;
	font-family: "MetropolisRegular";
	padding-top: 0.5rem;

	b {
		font-family: var(--font-family-metropolis-semi-bold);
	}
`;

export const ContainerPinCode = styled.div`
	padding-top: 1.5rem;
	width: 100%;

	@media only screen and (max-device-width: 900px) {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: column;
	}
`;

export const MessageError = styled.span`
	color: #d30d48;
	font-family: var(--font-family-metropolis-semi-bold);
	font-size: 12px;
`;

export const ButtonContainer = styled.div`
	margin-top: 40px;
	width: 100%;

	label {
		margin-bottom: 0;
	}
`;

export const Label = styled.label`
	font-size: 16px;
	font-family: "MetropolisRegular";
	color: #ffffff;
	padding-bottom: 0.5rem;
`;

export const DivButtonConfirm = styled.div`
	display: flex;
	justify-content: space-between;
	font-family: var(--font-family-metropolis-semi-bold);
`;

export const ButtonRecover = styled.button`
	display: flex;
	justify-content: center;
	background: transparent;
	color: #01e59b;
	text-decoration: none;
	font-size: 16px;
	width: 13rem;
	height: 40px;
	border: 2px solid #01e59b;
	border-radius: 8px;
	align-items: center;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		color: #01e59b;
		text-decoration: underline;
	}

	img {
		margin-right: 4px;
	}

	@media only screen and (max-device-width: 900px) {
		width: 11.2rem;
	}

	@media only screen and (max-device-width: 380px) {
		width: 9.75rem;
	}
`;

export const DivTimer = styled.div`
	display: flex;
	justify-content: center;
	font-family: "MetropolisRegular";
	margin-top: 48px;
	width: 100%;

	span {
		color: #01e59b;
		font-size: 16px;
	}
`;
